module.exports = __webpack_public_path__ + "img/pro_15.896e33c2.jpg";